import { DashboardScreenContent } from "../../features/dashboard";

function DashboardScreen() {
  return (
    <section className="clients-page" id="Csection" tabIndex="-1">
      <div className="container">
        <DashboardScreenContent />
      </div>
    </section>
  );
}

export default DashboardScreen;
